module.exports = __webpack_public_path__ + "images/10fb93c46282579a6c641f14a06c978b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/react/images/uerm/IND-KET-1-L.jpg
// module id = 765
// module chunks = 0